<template>
  <div class="container-tab">
    <div class="tab-list">
      <div class="all-menu" @click="$router.push('/goodsCategory')">
        全部药品分类
      </div>
      <div class="other-meun">
        <div><router-link to="/">首页</router-link></div>
        <div><router-link to="/news">行业资讯</router-link></div>
        <!-- <div><router-link to="/buyDrug">药品求购</router-link></div> -->
        <div @click="sign">每日签到</div>
      </div>
    </div>
    <SignIn ref="signIn"></SignIn>
  </div>
</template>

<script>
import SignIn from "@components/pc/nav/SignIn";
export default {
  name: "CommonTab",
  components: {
    SignIn
  },
  methods: {
    sign() {
      this.$refs.signIn.sign();
    }
  }
};
</script>

<style lang="stylus" scoped>
.container-tab
  background #fff
  border-bottom 2px solid #3284dd
  .tab-list
    width 1200px
    margin 0 auto
    display flex
    height 40px
    .all-menu
      width 200px
      background #1880f4
      color #fff
      font-size 16px
      font-weight 400
      line-height 40px
      text-align center
      cursor pointer
    .other-meun
      display flex
      margin-left 25px
      font-size 16px
      div
        cursor pointer
        letter-spacing 2px
        line-height 40px
        padding 0 25px
        &:hover
          color #1880f4
</style>
